import { filter } from 'lodash';
import React, { useState, useEffect } from 'react';
import {
    Card, Table, Button, TableRow, TableBody, TableCell, Container, TableContainer, TablePagination
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/user';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { GetUpcomingMatchListAction, MatchChangeStatusAction,CancelMatchAction, ResetMatchChangeStatusAction } from '../../redux/actions/MatchAction';
import Loader from "./../../components/Loader"
import moment from 'moment';
function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

export default function UpcomingMatches() {
    const dispatch = useDispatch();
    const loadingSelector = useSelector(state => state.matches.loading)
    const statusSelector = useSelector(state => state.matches.match_status)
    const ContestListData = useSelector(state => state.matches.upcoming_match_list.data)
    const ContestList = ContestListData !== undefined && ContestListData.data.match_list

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [order, setOrder] = useState('asc');
    const [selected, setSelected] = useState([]);
    const [orderBy, setOrderBy] = useState('name');
    const [filterName, setFilterName] = useState('');
    const [clickStatus, setClickStatus] = useState(false)
    const [state, setState] = useState({
        ContestListData: [],
        totalCountContestList: 0,
        logoImg: [],
        title: '',
        subtitle: '',
        dis_val: ''
    })

    useEffect(() => {
        if (ContestListData !== undefined) {
            setState({ ...state, ContestListData: ContestListData.data.match_list, totalCountContestList: ContestListData.data.total_count })
        }
    }, [ContestListData])

    useEffect(() => {
        dispatch(GetUpcomingMatchListAction(page, rowsPerPage))
        setClickStatus(false)
        return () => {
            dispatch(ResetMatchChangeStatusAction())
        }
    }, [dispatch, page, rowsPerPage])

    useEffect(() => {
        if (Object.keys(statusSelector).length > 0) {
            dispatch(GetUpcomingMatchListAction(page, rowsPerPage))
            setClickStatus(false)
        }
    }, [statusSelector, page, rowsPerPage])

    const handleRequestSort = (_, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (_, newPage) => {
        setClickStatus(true)
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setClickStatus(true)
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    };

    const handleFilterByName = (event) => {
        setFilterName(event.target.value);
    };

    const applySortFilter = (array, comparator, query) => {
        const stabilizedThis = array && array.map((el, index) => [el, index]);
        if (stabilizedThis) {
            stabilizedThis.sort((a, b) => {
                const order = comparator(a[0], b[0]);
                if (order !== 0) return order;
                return a[1] - b[1];
            });
        }
        if (query) {
            return filter(array, (_user) => _user?.title?.toLowerCase()?.indexOf(query?.toLowerCase()) !== -1);
        }
        const filterData = stabilizedThis && stabilizedThis.map((el) => el[0])
        return filterData;
    }

    const filteredUsers = applySortFilter(ContestList, getComparator(order, orderBy), filterName);

    const activateMatch = (event, is_active, match_id) => {
        setClickStatus(true)
        event.preventDefault()
        let sendData = {
            match_id: match_id,
            is_active: is_active
        }
        dispatch(MatchChangeStatusAction(sendData))
    }

    const InactivateMatch = (event, is_active, match_id) => {
        setClickStatus(true)
        event.preventDefault()
        let sendData = {
            match_id: match_id,
            is_active: is_active
        }
        dispatch(MatchChangeStatusAction(sendData))
    }

    const CancelMatch = (event, is_cancel, match_id) => {
        setClickStatus(true)
        event.preventDefault()
        let sendData = {
            match_id: match_id,
            r_status: is_cancel
        }
        dispatch(CancelMatchAction(sendData))
    }

    return (
        <Page title="Upcoming Matches">
            {clickStatus || loadingSelector ? <Loader /> : null}
            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Upcoming Match List"
                    links={[
                        { name: 'Dashboard', href: "/dashboard/app" },
                        { name: 'Upcoming Contest' }
                    ]}
                />

                <Card>
                    {/* <UserListToolbar
                        numSelected={selected.length}
                        filterName={filterName}
                        onFilterName={handleFilterByName}
                        placeholder="Search team..."
                    /> */}

                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    order={order}
                                    orderBy={orderBy}
                                    headLabel={[
                                        { id: 'c_no', label: 'Sr no.', alignRight: false },
                                        { id: 'c_id', label: 'Match ID', alignRight: false },
                                        { id: 'c_team1vsteam2', label: 'Teams Title', alignRight: false },
                                        { id: 'c_subtitle', label: 'Subtitle', alignRight: false },
                                        { id: 'c_date', label: 'Date & Time', alignRight: false },
                                        { id: 'c_action', label: 'Actions', alignRight: false }
                                    ]}
                                    rowCount={state.totalCountContestList}
                                    numSelected={selected.length}
                                    // onRequestSort={handleRequestSort}
                                />
                                <TableBody>
                                    {filteredUsers ?
                                        filteredUsers.map((data, index) => {
                                            return (
                                                data.is_active != 2 ?
                                                    <TableRow
                                                        key={index}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {page * rowsPerPage + (index + 1)}.
                                                        </TableCell>
                                                        <TableCell component="th" scope="row"> {data.match_id}</TableCell>
                                                        <TableCell component="th" scope="row"> {data.title}</TableCell>
                                                        <TableCell component="th" scope="row"> {data.subtitle}</TableCell>

                                                        <TableCell component="th" scope="row">
                                                            {data.date_start_ist ? new Date(data.date_start_ist).toUTCString().split("GMT")[0] : "-"}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {data.is_active === 1 ? <Button size="small" color="success" onClick={(event) => activateMatch(event, 0, data.match_id)}>Active</Button> : <Button size="small" color="error" onClick={(event) => InactivateMatch(event, 1, data.match_id)}>Inactive</Button>}

                                                            {/* <Button size="small" color="error" onClick={(event) => CancelMatch(event, 3, data.match_id)}>Cancel Match</Button> */}


                                                        </TableCell>
                                                    </TableRow>
                                                    :
                                                    ""
                                            )

                                        })
                                        : <Loader />
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>

                    <TablePagination
                        rowsPerPageOptions={[25, 50, 100, 150, 200]}
                        component="div"
                        count={state.totalCountContestList}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </Container>
        </Page>
    );
}
